import { NotificationCategoryType } from "PFTypes/notifications";

const CATEGORY_TYPE_CHANGED_PATTERNS = [
  /^role_.*_changed$/,
  /^audit_role_.*_changed$/,
  /^engagement_.*_changed$/,
  /^audit_engagement_.*_changed$/
];

const QUICK_LINK_CATEGORY_TYPES = [
  NotificationCategoryType.ActivityTagChanged,
  NotificationCategoryType.RoleClosed,
  NotificationCategoryType.RoleExpiring,
  NotificationCategoryType.RoleFilled,
  NotificationCategoryType.RoleFilledForReviewer,
  NotificationCategoryType.VacancyClosed,
  NotificationCategoryType.InterestedRoleClosed,
  NotificationCategoryType.EngagementScenarioShared,
  NotificationCategoryType.OwnerRole,
  NotificationCategoryType.OwnerEngagement,
  NotificationCategoryType.Assignee,
  NotificationCategoryType.EngagementAssigned,
  NotificationCategoryType.AssigneeRemoved,
  NotificationCategoryType.HelpRequested,
  NotificationCategoryType.ShortlistCreated,
  NotificationCategoryType.ShortlistAssigned,
  NotificationCategoryType.NewRoleAccepted,
  NotificationCategoryType.NewRoleDeclined,
  NotificationCategoryType.ExceptionApproved,
  NotificationCategoryType.ExceptionRejected,
  NotificationCategoryType.BookingApprovalRequests,
  NotificationCategoryType.BookingReviewed,
  NotificationCategoryType.BookingCategoryChanged
];

export const checkNotificationHasQuickLinks = (categoryType: string): boolean =>
  QUICK_LINK_CATEGORY_TYPES.includes(categoryType as NotificationCategoryType) ||
  CATEGORY_TYPE_CHANGED_PATTERNS.some((pattern) => pattern.test(categoryType));

export const getOpenActivityLabelKey = (isEngagement: boolean, isAudit: boolean) => {
  if (isEngagement) {
    return isAudit ? "openAuditEngagement" : "openEngagement";
  }

  return isAudit ? "openAuditRole" : "openRole";
};
